import { AnalyticsPageRouting, AnalyticsProvider } from '@air/marketing-analytics';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import { ReactNode } from 'react';

import { DefaultFooter } from '~/old-marketing/components/globals/footers/DefaultFooter';
import { GlobalStyle } from '~/old-marketing/components/GlobalStyle';

export const AgencyLayout = ({ children, layout }: { children: ReactNode; layout: { seo: { title: string } } }) => {
  return (
    <AnalyticsProvider>
      <AnalyticsPageRouting />
      <Head>
        <link href="/fonts/brice/brice.css" rel="stylesheet" key="gelica-font" />
      </Head>

      <GlobalStyle />

      <NextSeo
        description="Take your brand to new heights. Find the right agency for you."
        openGraph={{
          title: layout?.seo?.title ?? 'The Agency Directory',
          images: [
            {
              url: '/assets/marketing/agency-share-image.png',
              width: 600,
              height: 315,
            },
          ],
        }}
        title={layout?.seo?.title ?? 'The Agency Directory'}
        titleTemplate={layout?.seo?.title ? '%s | The Agency Directory' : '%s'}
      />

      {children}

      <DefaultFooter />
    </AnalyticsProvider>
  );
};
